// src/store/reducers/index.js
import { combineReducers } from 'redux';
import languageReducer from './languageReducer';
import messageReducer from './messageReducer';
import wishlistReducer from "./wishlistReducer";
import cartReducer from "./cartReducer";
import categoryReducer from "./categoryReducer";
import currencyReducer from "./currencyReducer";


// Combine all reducers
const rootReducer = combineReducers({
    cart: cartReducer,
    category: categoryReducer,
    language: languageReducer,
    messages: messageReducer,
    wishlist: wishlistReducer,
    currency: currencyReducer,
});
export default rootReducer;